module.exports = __webpack_public_path__ + "static/assets/3d3081fcfb0e88e0c6806aad45d405d2.png";